export default __webpack_public_path__ + "static/media/scroll-chevron.defa0ca2.svg";